<proffeo-ui-page-wrapper>
  <div class="flex w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="projectLocations() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface"
    >
      @if (projectLocations()?.length === 0) {
        <div class="flex w-full items-center justify-center p-4">
          <p class="font-medium">{{ 'placeholders.no-results-found' | translate }}</p>
        </div>
      } @else if (projectLocations()) {
        <proffeo-project-location />
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
